"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSentryFeaturesConfig = exports.useAppSentryConfig = void 0;
const Sentry = __importStar(require("@sentry/nextjs"));
const react_1 = require("react");
function useAppSentryConfig(config) {
    const { user } = config;
    // only browser, server-side is set in SSP functions
    (0, react_1.useEffect)(() => {
        if (!user)
            return;
        Sentry.setUser({
            id: user.userId,
            ip_address: `{{auto}}`,
        });
        Sentry.setTags({
            channel_type: user.channel,
        });
    }, [user]);
}
exports.useAppSentryConfig = useAppSentryConfig;
const TAG_KEY_MAX = 32;
function setSentryFeaturesConfig(config) {
    const enabledFeatures = Object.entries(config)
        .filter(([, v]) => v.enabled)
        .map(([n, v]) => [`f.${n}`.substring(0, TAG_KEY_MAX), v.enabled]);
    const enabledVariants = Object.entries(config)
        .filter(([, v]) => { var _a; return v.enabled && ((_a = v.variant) === null || _a === void 0 ? void 0 : _a.enabled); })
        .map(([n, v]) => [`fv.${n}`.substring(0, TAG_KEY_MAX), v.variant.name]);
    const tags = Object.fromEntries(enabledFeatures.concat(enabledVariants));
    Sentry.setTags(tags);
}
exports.setSentryFeaturesConfig = setSentryFeaturesConfig;
//# sourceMappingURL=index.js.map